export default function signupEvent() {
  return gtag('event', 'sign_up');
}
